/**
 * Agreement Server
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorModel } from '../model/errorModel';
// @ts-ignore
import { ResponseMessage } from '../model/responseMessage';
// @ts-ignore
import { Sftp } from '../model/sftp';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    SftpServiceInterface
} from './sftp.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class SftpService extends BaseService implements SftpServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Delete sftp servers
     * @param accessToken System access token
     * @param id SFTP server database id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sftpDelete(accessToken: string, id: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public sftpDelete(accessToken: string, id: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public sftpDelete(accessToken: string, id: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public sftpDelete(accessToken: string, id: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling sftpDelete.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling sftpDelete.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (id !== undefined && id !== null) {
            localVarFormParams = localVarFormParams.append('id', <any>id) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/sftp`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get user sftp servers
     * @param accessToken System access token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sftpGet(accessToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<Sftp>>;
    public sftpGet(accessToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<Sftp>>>;
    public sftpGet(accessToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<Sftp>>>;
    public sftpGet(accessToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling sftpGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/sftp`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Sftp>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of sftp servers that the user allowed to send documents
     * @param accessToken System access token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sftpListGet(accessToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<Sftp>>;
    public sftpListGet(accessToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<Sftp>>>;
    public sftpListGet(accessToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<Sftp>>>;
    public sftpListGet(accessToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling sftpListGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/sftp/list`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Sftp>>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update sftp server
     * @param accessToken System access token
     * @param id SFTP server  id
     * @param serverName SFTP server name
     * @param serverAddress SFTP server address
     * @param serverPort SFTP server Port
     * @param serverUsername SFTP server username
     * @param serverPassword SFTP server password
     * @param serverDirectory SFTP server directory
     * @param departments Departments that can use this sftp server. Values are comma separated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sftpPost(accessToken: string, id: string, serverName: string, serverAddress: string, serverPort: string, serverUsername: string, serverPassword: string, serverDirectory: string, departments: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public sftpPost(accessToken: string, id: string, serverName: string, serverAddress: string, serverPort: string, serverUsername: string, serverPassword: string, serverDirectory: string, departments: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public sftpPost(accessToken: string, id: string, serverName: string, serverAddress: string, serverPort: string, serverUsername: string, serverPassword: string, serverDirectory: string, departments: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public sftpPost(accessToken: string, id: string, serverName: string, serverAddress: string, serverPort: string, serverUsername: string, serverPassword: string, serverDirectory: string, departments: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling sftpPost.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling sftpPost.');
        }
        if (serverName === null || serverName === undefined) {
            throw new Error('Required parameter serverName was null or undefined when calling sftpPost.');
        }
        if (serverAddress === null || serverAddress === undefined) {
            throw new Error('Required parameter serverAddress was null or undefined when calling sftpPost.');
        }
        if (serverPort === null || serverPort === undefined) {
            throw new Error('Required parameter serverPort was null or undefined when calling sftpPost.');
        }
        if (serverUsername === null || serverUsername === undefined) {
            throw new Error('Required parameter serverUsername was null or undefined when calling sftpPost.');
        }
        if (serverPassword === null || serverPassword === undefined) {
            throw new Error('Required parameter serverPassword was null or undefined when calling sftpPost.');
        }
        if (serverDirectory === null || serverDirectory === undefined) {
            throw new Error('Required parameter serverDirectory was null or undefined when calling sftpPost.');
        }
        if (departments === null || departments === undefined) {
            throw new Error('Required parameter departments was null or undefined when calling sftpPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (id !== undefined && id !== null) {
            localVarFormParams = localVarFormParams.append('id', <any>id) as any || localVarFormParams;
        }
        if (serverName !== undefined && serverName !== null) {
            localVarFormParams = localVarFormParams.append('server_name', <any>serverName) as any || localVarFormParams;
        }
        if (serverAddress !== undefined && serverAddress !== null) {
            localVarFormParams = localVarFormParams.append('server_address', <any>serverAddress) as any || localVarFormParams;
        }
        if (serverPort !== undefined && serverPort !== null) {
            localVarFormParams = localVarFormParams.append('server_port', <any>serverPort) as any || localVarFormParams;
        }
        if (serverUsername !== undefined && serverUsername !== null) {
            localVarFormParams = localVarFormParams.append('server_username', <any>serverUsername) as any || localVarFormParams;
        }
        if (serverPassword !== undefined && serverPassword !== null) {
            localVarFormParams = localVarFormParams.append('server_password', <any>serverPassword) as any || localVarFormParams;
        }
        if (serverDirectory !== undefined && serverDirectory !== null) {
            localVarFormParams = localVarFormParams.append('server_directory', <any>serverDirectory) as any || localVarFormParams;
        }
        if (departments !== undefined && departments !== null) {
            localVarFormParams = localVarFormParams.append('departments', <any>departments) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/sftp`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create new sftp server
     * @param accessToken System access token
     * @param serverName SFTP server name
     * @param serverAddress SFTP server address
     * @param serverPort SFTP server Port
     * @param serverUsername SFTP server username
     * @param serverPassword SFTP server password
     * @param serverDirectory SFTP server directory
     * @param departments Departments that can use this sftp server. Values are comma separated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sftpPut(accessToken: string, serverName: string, serverAddress: string, serverPort: string, serverUsername: string, serverPassword: string, serverDirectory: string, departments: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public sftpPut(accessToken: string, serverName: string, serverAddress: string, serverPort: string, serverUsername: string, serverPassword: string, serverDirectory: string, departments: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public sftpPut(accessToken: string, serverName: string, serverAddress: string, serverPort: string, serverUsername: string, serverPassword: string, serverDirectory: string, departments: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public sftpPut(accessToken: string, serverName: string, serverAddress: string, serverPort: string, serverUsername: string, serverPassword: string, serverDirectory: string, departments: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling sftpPut.');
        }
        if (serverName === null || serverName === undefined) {
            throw new Error('Required parameter serverName was null or undefined when calling sftpPut.');
        }
        if (serverAddress === null || serverAddress === undefined) {
            throw new Error('Required parameter serverAddress was null or undefined when calling sftpPut.');
        }
        if (serverPort === null || serverPort === undefined) {
            throw new Error('Required parameter serverPort was null or undefined when calling sftpPut.');
        }
        if (serverUsername === null || serverUsername === undefined) {
            throw new Error('Required parameter serverUsername was null or undefined when calling sftpPut.');
        }
        if (serverPassword === null || serverPassword === undefined) {
            throw new Error('Required parameter serverPassword was null or undefined when calling sftpPut.');
        }
        if (serverDirectory === null || serverDirectory === undefined) {
            throw new Error('Required parameter serverDirectory was null or undefined when calling sftpPut.');
        }
        if (departments === null || departments === undefined) {
            throw new Error('Required parameter departments was null or undefined when calling sftpPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (serverName !== undefined && serverName !== null) {
            localVarFormParams = localVarFormParams.append('server_name', <any>serverName) as any || localVarFormParams;
        }
        if (serverAddress !== undefined && serverAddress !== null) {
            localVarFormParams = localVarFormParams.append('server_address', <any>serverAddress) as any || localVarFormParams;
        }
        if (serverPort !== undefined && serverPort !== null) {
            localVarFormParams = localVarFormParams.append('server_port', <any>serverPort) as any || localVarFormParams;
        }
        if (serverUsername !== undefined && serverUsername !== null) {
            localVarFormParams = localVarFormParams.append('server_username', <any>serverUsername) as any || localVarFormParams;
        }
        if (serverPassword !== undefined && serverPassword !== null) {
            localVarFormParams = localVarFormParams.append('server_password', <any>serverPassword) as any || localVarFormParams;
        }
        if (serverDirectory !== undefined && serverDirectory !== null) {
            localVarFormParams = localVarFormParams.append('server_directory', <any>serverDirectory) as any || localVarFormParams;
        }
        if (departments !== undefined && departments !== null) {
            localVarFormParams = localVarFormParams.append('departments', <any>departments) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/sftp`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Send document to sftp server
     * @param accessToken System access token
     * @param sftpId SFTP server database id
     * @param jobId job id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public sftpSendPost(accessToken: string, sftpId: string, jobId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public sftpSendPost(accessToken: string, sftpId: string, jobId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public sftpSendPost(accessToken: string, sftpId: string, jobId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public sftpSendPost(accessToken: string, sftpId: string, jobId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling sftpSendPost.');
        }
        if (sftpId === null || sftpId === undefined) {
            throw new Error('Required parameter sftpId was null or undefined when calling sftpSendPost.');
        }
        if (jobId === null || jobId === undefined) {
            throw new Error('Required parameter jobId was null or undefined when calling sftpSendPost.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (sftpId !== undefined && sftpId !== null) {
            localVarFormParams = localVarFormParams.append('sftp_id', <any>sftpId) as any || localVarFormParams;
        }
        if (jobId !== undefined && jobId !== null) {
            localVarFormParams = localVarFormParams.append('job_id', <any>jobId) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/sftp/send`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
